import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConditionalAccessPolicy } from '@microsoft/microsoft-graph-types-beta';
import { select, Store } from '@ngrx/store';
import { client } from 'projects/angular-clarity/src/app/stores/client';
import { sample, take } from 'rxjs';

export interface CapMappingDialogData {
    selectedPolicyId: string | null;
    allPolicies: ConditionalAccessPolicy[];
    baselineId: string;
    tenantId: string;
}

@Component({
    selector: 'app-cap-mapping-dialog',
    templateUrl: './cap-mapping-dialog.component.html',
    styleUrls: ['./cap-mapping-dialog.component.scss'],
})
export class CapMappingDialogComponent implements OnInit {
    selectedPolicyId: string;
    allPolicies: ConditionalAccessPolicy[];
    baselineId: string;
    tenantId: string;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: CapMappingDialogData,
        private dialogRef: MatDialogRef<CapMappingDialogComponent>,
        private store: Store<any>,
    ) {
        this.selectedPolicyId = this.data.selectedPolicyId;
        this.allPolicies = this.data.allPolicies;
        this.baselineId = this.data.baselineId;
        this.tenantId = this.data.tenantId;
    }

    ngOnInit(): void {
        const baselines$ = this.store.pipe(select(client(this.tenantId).sway.baselines.byType('tenant')));
        const baselineStatus$ = this.store.pipe(select(client(this.tenantId).sway.baselines.status));

        baselines$.pipe(sample(baselineStatus$), take(1)).subscribe((allBaselines) => {
            const alreadyMappedPolicies = allBaselines
                .filter((baseline) => baseline.id !== this.baselineId) // Filter out baselines without a key, and filter the current baseline
                .map((baseline) => this.allPolicies.find((policy) => policy.id === baseline.key)) // Map keys to matching policies
                .filter((policy) => policy !== undefined); // Filter out undefined results (no matching policy)

            this.allPolicies = this.allPolicies.filter(
                (policy) => !alreadyMappedPolicies.find((p) => p.id === policy.id),
            );
        });
    }

    onConfirm() {
        this.dialogRef.close({ success: true, data: { id: this.selectedPolicyId } });
    }
}
